import { Component, AfterViewInit, ViewChild, ElementRef, HostListener } from "@angular/core";
import { createPopper } from "@popperjs/core";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-user-account-dropdown",
  templateUrl: "./user-account-dropdown.component.html",
})
export class UserAccountDropdownComponent implements AfterViewInit {

  dropdownPopoverShow2 = false;
  @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef;
  @ViewChild("popoverDropdownRef2", { static: false })
  popoverDropdownRef2: ElementRef;
  ngAfterViewInit() {
    createPopper(
      this.btnDropdownRef.nativeElement,
      this.popoverDropdownRef2.nativeElement,
      {
        placement: "bottom-start",
      }
    );
  }
  toggleDropdown(event) {
    event.preventDefault();
    if (this.dropdownPopoverShow2) {
      this.dropdownPopoverShow2 = false;
    } else {
      this.dropdownPopoverShow2 = true;
    }
  }
  // Listen for clicks on the document
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      this.dropdownPopoverShow2 &&
      !this.btnDropdownRef.nativeElement.contains(target) &&
      !this.popoverDropdownRef2.nativeElement.contains(target)
    ) {
      this.dropdownPopoverShow2 = false;
    }
  }

}
